import * as React from 'react'

function SvgTt(props) {
	return (
		<svg viewBox="0 0 30 18" width="1em" height="1em" {...props}>
			<path fill="#CE1126" d="M0 0h30v18H0z" />
			<path fill="#FFF" d="M0 0l20.825 18H30L9.175 0z" />
			<path d="M1.53 0l20.824 18h6.117L7.646 0z" />
		</svg>
	)
}

export default SvgTt
